module.exports = __webpack_public_path__ + "img/IND-A-1-IV.7bd83cb5.png";